import ReactImageFallback from 'react-image-fallback'
import renameUnsafeLifecycleMethods from 'd2/hocs/RenameUnsafeLifecycleMethods'

// TODO: This is a temporary solution while we are waiting for
// react-image-fallback lib to be updated (or find a better alternative lib).

export default renameUnsafeLifecycleMethods(ReactImageFallback)
